import clsx from 'clsx';

import { CpcConnectButton } from '~/components/cpc/CpcConnectButton';
import { CpcLanguageSelect } from '~/components/cpc/CpcLanguageSelect';
import { CpcWalletBar } from '~/components/cpc/CpcWalletBar';
import { useT } from '~/i18n/LocaleContext';
import NetworkSelect from '../network/Network';

type AsideBottomPanelProps = {
	className?: string;
	compact?: boolean;
};

export function AsideBottomPanel({ className, compact }: AsideBottomPanelProps) {
	const t = useT();

	return (
		<div
			className={clsx(
				'rounded-xl border border-white/10 bg-[#1E293B]/60 p-3',
				compact ? 'space-y-2.5' : 'space-y-3',
				className,
			)}
		>
			<div>
				<p className="mb-1.5 px-0.5 text-[10px] font-semibold uppercase tracking-wider text-[#94a3b8]">
					{t('common.language')}
				</p>
				<CpcLanguageSelect compact />
			</div>

			<div>
				<p className="mb-1.5 px-0.5 text-[10px] font-semibold uppercase tracking-wider text-[#94a3b8]">
					{t('common.network')}
				</p>
				<div
					className={clsx(
						'[&_button]:flex [&_button]:h-10 [&_button]:w-full [&_button]:items-center',
						'[&_button]:justify-between [&_button]:rounded-lg [&_button]:border [&_button]:border-white/10',
						'[&_button]:bg-[#0F172A]/80 [&_button]:px-3 [&_button]:text-left [&_button]:text-sm',
						'[&_button]:font-medium [&_button]:!text-[#e2e8f0]',
						'[&_button]:transition-colors [&_button]:hover:border-[#38BDF8]/30 [&_button]:hover:bg-[#0F172A]',
					)}
				>
					<NetworkSelect />
				</div>
			</div>

			<div>
				<p className="mb-1.5 px-0.5 text-[10px] font-semibold uppercase tracking-wider text-[#94a3b8]">
					{t('common.wallet')}
				</p>
				<div className="space-y-2">
					<CpcWalletBar variant="sidebar" />
					<CpcConnectButton variant="sidebar" />
				</div>
			</div>
		</div>
	);
}
